import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Semantic UI Default CSS Package https://react.semantic-ui.com/usage#theme
import 'semantic-ui-css/semantic.min.css' 

ReactDOM.render(<App />, document.getElementById('root'));